import React from 'react';
import { ReactComponent as Logo8fig } from '../../../public/logos/8fig-logo.svg';
import { ReactComponent as Logo8data } from '../../../public/logos/8data/8data-logo-white.svg';
import { useSideBarContext } from '../../contexts/SideBar';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { is8DataApp } from '../../utils';

const useStyles = makeStyles((theme: any) => ({
  banner: { display: 'flex', justifyContent: 'center' },
  openMenuButton: {
    position: 'absolute',
    left: theme.spacing(1),
    color: theme.palette.brand.white,
  },
}));

export default function MobileBanner() {
  const classes = useStyles();
  const { setOpen } = useSideBarContext();
  const is8Data = is8DataApp();

  return (
    <AppBar>
      <Toolbar className={classes.banner}>
        <IconButton
          edge="start"
          color="inherit"
          className={classes.openMenuButton}
          onClick={() => setOpen(true)}
        >
          <MenuIcon />
        </IconButton>
        {is8Data ? <Logo8data /> : <Logo8fig />}
      </Toolbar>
    </AppBar>
  );
}
